module.exports = "/images/london-28.jpg";